import {useMediaQuery} from "@mui/material";

export const useIsMobile = (query?: string) => {
	const isMobile = useMediaQuery(query || "(max-width: 900px)");
	const isMobileShare = "share" in navigator && isMobile;

	return {isMobileShare, isMobile};
};
